/// <amd-module name="TFS/Admin/Common/RestClient/HostAcquisition" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\hostacquisition.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as HostAcquisition from "TFS/Admin/Common/Contracts/HostAcquisition";
import * as Organization from "TFS/Admin/Common/Contracts/Organization";

export interface IHostAcquisitionRestClient extends IVssRestClient {
    /**
     * Creates a new collection of the given name in the given region
     * 
     * @param properties - 
     * @param collectionName - 
     * @param preferredRegion - 
     * @param ownerDescriptor - 
     */
    createCollection(properties: { [key: string] : string; }, collectionName: string, preferredRegion: string, ownerDescriptor?: string): Promise<Organization.Collection>;
    /**
     * @param name - 
     */
    getNameAvailability(name: string): Promise<HostAcquisition.NameAvailability>;
    /**
     */
    getRegions(): Promise<HostAcquisition.Region[]>;
}

class HostAcquisitionRestClient extends RestClientBase implements IHostAcquisitionRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Creates a new collection of the given name in the given region
     * 
     * @param properties - 
     * @param collectionName - 
     * @param preferredRegion - 
     * @param ownerDescriptor - 
     */
    public async createCollection(
        properties: { [key: string] : string; },
        collectionName: string,
        preferredRegion: string,
        ownerDescriptor?: string
        ): Promise<Organization.Collection> {

        const queryValues: any = {
            collectionName: collectionName,
            preferredRegion: preferredRegion,
            ownerDescriptor: ownerDescriptor
        };

        return this.beginRequest<Organization.Collection>({
            apiVersion: "5.0-preview.2",
            method: "POST",
            routeTemplate: "_apis/HostAcquisition/Collections",
            queryParams: queryValues,
            body: properties
        });
    }

    /**
     * @param name - 
     */
    public async getNameAvailability(
        name: string
        ): Promise<HostAcquisition.NameAvailability> {

        return this.beginRequest<HostAcquisition.NameAvailability>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/HostAcquisition/NameAvailability/{name}",
            routeValues: {
                name: name
            }
        });
    }

    /**
     */
    public async getRegions(
        ): Promise<HostAcquisition.Region[]> {

        return this.beginRequest<HostAcquisition.Region[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/HostAcquisition/Regions"
        });
    }

}

export const HostAcquisitionClientName = "Organization-Admin.IHostAcquisitionRestClient";

export function getHostAcquisitionClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IHostAcquisitionRestClient {
    return pageContext.getRestClient<IHostAcquisitionRestClient>(HostAcquisitionClientName, options);
}

RestClients.add(HostAcquisitionClientName, { 
    factory: HostAcquisitionRestClient,
    options: {
        serviceInstanceType: "00000041-0000-8888-8000-000000000000"
    }
});
